// extracted by mini-css-extract-plugin
export default {"activeIconColor":"NsHMwG_bhF7_vTs8mbSQ","socialInput":"kZruh5cw6PvNz7yQBInc","thumbnail":"noJLFJCf4xCZ9BkPZQNU","socialsList":"BaXR77yHOue2baK03l_A"};